import { createTypedHooks } from 'easy-peasy';
import { IStoreModel } from './types';

export const { useStoreActions, useStoreState } = createTypedHooks<IStoreModel>();
